<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <t-input v-model="form.accessControlId" hidden/>

      <t-input v-model="form.name"  :add-error="error.name" label="Apelido do Local" required/>

      <t-input v-model="form.ip" :add-error="error.ip" label="IP" />


      <t-msg info class="mt-2">Seu IP atual é: {{currentIP}}</t-msg>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'AccessControlForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "accessControlId",
      form: {
        accessControlId: 0,
        accessControlNumber: 0,
        name: "",
        ip: "",
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        ip: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      currentIP: "",
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      this.$http.get('https://www.oxserver.com.br/sistema_online/ip.asp')
          .then(response => {
            this.currentIP = response.data

          }).catch(
          error => {
            console.log(error)
            this.localBusy = false
          }
      )


      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
